
export const surveyStyles = ((theme) => ({
  
  heading: {
    fontSize: '0.875rem',
    color: '#004F9F',
    // width: '100%',
  },
  box: {
    width: '100%',
    display: 'flex',
  },
  iconG: {
    color: '#4caf50',
    marginRight: 2,
  },
  iconB: {
    color: '#f6685e',
    marginRight: 2,
  },
  iconW: {
    color: '#ffb74d',
    marginRight: 2,
  },
  text: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    marginRight: 20
  },
  bad: '#f6685e',
  good: '#4caf50',
}));